import React, { FunctionComponent } from 'react';

import {
  SingleFieldStepProps,
  UNDER_1_TO_FIVE_PLUS_OPTIONS,
} from 'scenes/common/types';
import SingleSegmentedControlStep from 'scenes/common/components/Steps/SingleSegmentedControlStep';

const STATE_KEY = 'yearsInsured';
export const QUESTION =
  'For how many years in a row has the policy holder had building and/or contents insurance?';

const YearsInsuredStep: FunctionComponent<Pick<
  SingleFieldStepProps<number>,
  'defaultStateValue' | 'onNext'
>> = ({ defaultStateValue, onNext }) => (
  <SingleSegmentedControlStep
    onNext={onNext}
    question={QUESTION}
    stateKey={STATE_KEY}
    options={UNDER_1_TO_FIVE_PLUS_OPTIONS}
    defaultStateValue={defaultStateValue}
    validationRules={{
      validate: {
        oneOf: (value: number) =>
          UNDER_1_TO_FIVE_PLUS_OPTIONS.some((option) => option.value === value),
      },
    }}
  />
);

export default YearsInsuredStep;
